var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-btn",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_c('v-icon',{attrs:{"size":"12"}},[_vm._v("fa-solid fa-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }